var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.2 13.6C4.87 13.6 4.5875 13.4825 4.3525 13.2475C4.1175 13.0125 4 12.73 4 12.4V4.4H3.2V3.2H6.4V2.4H9.6V3.2H12.8V4.4H12V12.3928C12 12.7309 11.8825 13.0167 11.6475 13.25C11.4125 13.4833 11.13 13.6 10.8 13.6H5.2ZM10.8 4.4H5.2V12.4H10.8V4.4ZM6.4 11.2H7.6V5.6H6.4V11.2ZM8.4 11.2H9.6V5.6H8.4V11.2Z",
    fill: "#A10902"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.77bf370e6aa713e1ad2292eb37f37f5e.svg";
export { ForwardRef as ReactComponent };